import { of as ofObservable, Observable,BehaviorSubject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ApiStatusService } from './../../../../../services/ApiStatus/api-status.service';
import { SelectionModel } from '@angular/cdk/collections';
import { MatTreeFlattener, MatTreeFlatDataSource } from '@angular/material/tree';
import { FlatTreeControl } from '@angular/cdk/tree';
import { tree } from 'src/app/entity/TreeView';

import { Component, OnInit, Output, EventEmitter, Input, SimpleChanges } from '@angular/core';
import { Rdv } from 'src/app/entity/Affaires/FilterAffaires';

export class TodoItemNode {
  children: TodoItemNode[];
  item: string;
  id: string;
}
export class TodoItemFlatNode {
  item: string;
  level: number;
  expandable: boolean;
  id: string;
}

const TREE_DATA = {};

export class ChecklistDatabase {
  dataChange: BehaviorSubject<TodoItemNode[]> = new BehaviorSubject<TodoItemNode[]>([]);

  get data(): TodoItemNode[] {
    return this.dataChange.value;
  }

  constructor() {
    this.initialize();
  }

  initialize() {
    if (TREE_DATA !== null && TREE_DATA !== undefined) {
      const data = this.buildFileTree(TREE_DATA, 0, 2);
      this.dataChange.next(data);
    }
  }

  buildFileTree(obj: { [key: string]: any }, level: number, keyLevels: number): TodoItemNode[] {
    return Object.keys(obj).reduce<TodoItemNode[]>((accumulator, key) => {
      const value = obj[key];
      const node = new TodoItemNode();
      node.item = key;

      if (value === null || value === undefined) {
        // no action
      } else if (typeof value === 'object' && level < keyLevels) {
        if (value !== null && value !== undefined) {
          node.children = this.buildFileTree(value, level + 1, keyLevels);
        }
      } else if (typeof value === 'object') {
        node.item = value['etat'];
        node.id = value['id'];
        if (value['child'].length > 0) {
          if (value['child'] !== null && value['child'] !== undefined) {
            node.children = this.buildFileTree(value['child'], level + 1, keyLevels);
          }
        }
      } else {
        node.item = value;
        node.id = value;
      }

      return accumulator.concat(node);
    }, []);
  }
}

@Component({
  selector: 'app-filter-statut-actuel-opp',
  templateUrl: './filter-statut-actuel-opp.component.html',
  styleUrls: ['./filter-statut-actuel-opp.component.css'],
  providers: [ChecklistDatabase],
})
export class FilterStatutActuelOppComponent implements OnInit {
  tree: tree[] = [];
  TreeData: tree[] = [];
  filterStatutActuelOpp: Rdv = new Rdv();

  @Output() onPushFilterStatutActuelOpp: EventEmitter<Rdv> = new EventEmitter();
  @Output() returnToparent = new EventEmitter<boolean>();
  @Input() Reset: any;
  flatNodeMap: Map<TodoItemFlatNode, TodoItemNode> = new Map<TodoItemFlatNode, TodoItemNode>();
  nestedNodeMap: Map<TodoItemNode, TodoItemFlatNode> = new Map<TodoItemNode, TodoItemFlatNode>();
  selectedParent: TodoItemFlatNode | null = null;
  treeControl: FlatTreeControl<TodoItemFlatNode>;
  treeFlattener: MatTreeFlattener<TodoItemNode, TodoItemFlatNode>;
  dataSource: MatTreeFlatDataSource<TodoItemNode, TodoItemFlatNode>;
  checklistSelection = new SelectionModel<TodoItemFlatNode>(false /* multiple */);

  etatRdv: any[];
  etatRendezVous: any[];
  selectedEtatRdv: any[];
  count: number = 0;
  filtre: any;
  constructor(private apiStatutService: ApiStatusService, private database: ChecklistDatabase) {
    this.treeFlattener = new MatTreeFlattener(this.transformer, this.getLevel, this.isExpandable, this.getChildren);
    this.treeControl = new FlatTreeControl<TodoItemFlatNode>(this.getLevel, this.isExpandable);
    this.dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);

    database.dataChange.subscribe((data) => {
      this.dataSource.data = data;
    });
  }

  async ngOnInit() {
    try {
      this.apiStatutService
        .GetTreeView()
        .pipe(
          tap(({ tree }) => {
            if (tree !== null && tree !== undefined) {
              this.dataSource.data = this.buildFileTree(tree, 0, 2);
              this.filtre = localStorage.getItem('filtreAffaire');
              this.filtre = JSON.parse(this.filtre)
              if (this.filtre) {
                this.filterStatutActuelOpp.etat_rdv =this.filtre.opp.rdv.etat_rdv
                this.checkedNodeIds=this.filterStatutActuelOpp.etat_rdv
                this.onPushFilterStatutActuelOpp.emit(this.filterStatutActuelOpp);
              }
            }
          })
        )
        .subscribe();
    } catch (err) {
      console.log(err);
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    this.resetStatutForm(changes.Reset.currentValue);
  }

  resetStatutForm(Reset) {
    if (Reset === true) {
      this.filterStatutActuelOpp = new Rdv();
      this.filterStatutActuelOpp.etat_rdv = [];
      this.onPushFilterStatutActuelOpp.emit(this.filterStatutActuelOpp);
      Reset = false;
      this.returnToparent.emit(Reset);
      this.ngOnInit();
    }
  }

  buildFileTree(obj: { [key: string]: any }, level: number, keyLevels: number): TodoItemNode[] {
    return Object.keys(obj).reduce<TodoItemNode[]>((accumulator, key) => {
      const value = obj[key];
      const node = new TodoItemNode();
      node.item = key;

      if (value === null || value === undefined) {
        // no action
      } else if (typeof value === 'object' && level < keyLevels) {
        if (value !== null && value !== undefined) {
          node.children = this.buildFileTree(value, level + 1, keyLevels);
        }
      } else if (typeof value === 'object') {
        node.item = value['etat'];
        node.id = value['id'];
        if (value['child'])
          if (value['child'].length > 0) {
            if (value['child'] !== null && value['child'] !== undefined) {
              node.children = this.buildFileTree(value['child'], level + 1, keyLevels);
            }
          }
      } else {
        node.item = value;
        node.id = value;
      }

      return accumulator.concat(node);
    }, []);
  }

  getLevel = (node: TodoItemFlatNode) => {
    return node.level;
  };

  isExpandable = (node: TodoItemFlatNode) => {
    return node.expandable;
  };

  getChildren = (node: TodoItemNode): Observable<TodoItemNode[]> => {
    return ofObservable(node.children);
  };

  hasChild = (_: number, _nodeData: TodoItemFlatNode) => {
    return _nodeData.expandable;
  };

  hasNoContent = (_: number, _nodeData: TodoItemFlatNode) => {
    return _nodeData.item === '';
  };

  transformer = (node: TodoItemNode, level: number) => {
    const existingNode = this.nestedNodeMap.get(node);
    const flatNode = existingNode && existingNode.item === node.item ? existingNode : new TodoItemFlatNode();
    flatNode.item = node.item;
    flatNode.level = level;
    flatNode.id = node.id;
    flatNode.expandable = !!node.children;
    this.flatNodeMap.set(flatNode, node);
    this.nestedNodeMap.set(node, flatNode);
    return flatNode;
  };

  /** Whether all the descendants of the node are selected. */
  descendantsAllSelected(node: TodoItemFlatNode): boolean {
    const descendants = this.treeControl.getDescendants(node);
    const descAllSelected = descendants.every((child) => this.checklistSelection.isSelected(child));

    this.etatRendezVous = this.checklistSelection.selected;
    const selectedElements = [];
    this.checklistSelection.selected.forEach((element) => {
      selectedElements.push(element.id);
    });
    this.filterStatutActuelOpp.etat_rdv = selectedElements;
    this.onPushFilterStatutActuelOpp.emit(this.filterStatutActuelOpp);
    return descAllSelected;
  }

  descendantsPartiallySelected(node: TodoItemFlatNode): boolean {
    const descendants = this.treeControl.getDescendants(node);
    const result = descendants.some((child) => this.checklistSelection.isSelected(child));
    return result && !this.descendantsAllSelected(node);
  }

  todoItemSelectionToggle(node: TodoItemFlatNode): void {
    this.checklistSelection.toggle(node);
    const descendants = this.treeControl.getDescendants(node);
    this.checklistSelection.isSelected(node)
      ? this.checklistSelection.select(...descendants)
      : this.checklistSelection.deselect(...descendants);

    // Force update for the parent
    descendants.every((child) => this.checklistSelection.isSelected(child));
    this.checkAllParentsSelection(node);
  }

  /** Toggle a leaf to-do item selection. Check all the parents to see if they changed */
  todoLeafItemSelectionToggle(node: TodoItemFlatNode, event): void {
    if (event.checked === true) {
      this.filterStatutActuelOpp.etat_rdv = this.unique(this.filterStatutActuelOpp.etat_rdv, node.id);
    } else {
      const index = this.filterStatutActuelOpp.etat_rdv.indexOf(node.id, 0);
      if (index > -1) {
        this.filterStatutActuelOpp.etat_rdv.splice(index, 1);
      }
    }

    this.onPushFilterStatutActuelOpp.emit(this.filterStatutActuelOpp);

    this.checklistSelection.toggle(node);

    this.checkAllParentsSelection(node);
  }

  unique = (set, item) => {
    return (set.includes(item) || set.push(item)) && set;
  };

  /* Checks all the parents when a leaf node is selected/unselected */
  checkAllParentsSelection(node: TodoItemFlatNode): void {
    let parent: TodoItemFlatNode | null = this.getParentNode(node);
    while (parent) {
      this.checkRootNodeSelection(parent);
      parent = this.getParentNode(parent);
    }
  }

  /** Check root node checked state and change it accordingly */
  checkRootNodeSelection(node: TodoItemFlatNode): void {
    const nodeSelected = this.checklistSelection.isSelected(node);
    const descendants = this.treeControl.getDescendants(node);
    const descAllSelected = descendants.every((child) => this.checklistSelection.isSelected(child));
    if (nodeSelected && !descAllSelected) {
      this.checklistSelection.deselect(node);
    } else if (!nodeSelected && descAllSelected) {
      this.checklistSelection.select(node);
    }
  }

  /* Get the parent node of a node */
  getParentNode(node: TodoItemFlatNode): TodoItemFlatNode | null {
    const currentLevel = this.getLevel(node);

    if (currentLevel < 1) {
      return null;
    }

    const startIndex = this.treeControl.dataNodes.indexOf(node) - 1;

    for (let i = startIndex; i >= 0; i--) {
      const currentNode = this.treeControl.dataNodes[i];

      if (this.getLevel(currentNode) < currentLevel) {
        return currentNode;
      }
    }
    return null;
  }

  getTreeView() {
    this.showloader();
    this.apiStatutService
      .GetTreeView()
      .pipe(
        tap(({ tree }) => {
          this.TreeData = tree;
        })
      )
      .subscribe();
  }

  hideloader() {
    document.getElementById('loadingBar').style.display = 'none';
  }

  showloader() {
    document.getElementById('loadingBar').style.display = 'block';
  }

  isLeaf(_: number, node: TodoItemFlatNode) {
    return !node.expandable;
  }



  checkedNodeIds: any[] = [];
  isChecked(node: TodoItemNode): boolean {
    return this.checkedNodeIds.includes(node.id); 
    
    // Replace 'id' with the actual property name holding the ID.
  }

  toggleNode(node: TodoItemNode): void {
    
    if (this.isChecked(node)) {
      
      this.checkedNodeIds = this.checkedNodeIds.filter(id => id !== node.id); // Replace 'id' with the actual property name holding the ID.
    } else {
      this.checkedNodeIds.push(node.id); // Replace 'id' with the actual property name holding the ID.
    }
    this.filterStatutActuelOpp.etat_rdv =this.checkedNodeIds;
    this.onPushFilterStatutActuelOpp.emit(this.filterStatutActuelOpp);
 console.log(" this.checkedNodeIds ", this.checkedNodeIds )
  }


}
